<template>
<div class="cell-frame row">
    <div class="col-1 align-self-center"><span class="wrap-text">{{invoiceApproval.staffId}}</span></div>
    <div class="col-2 align-self-center">
        <a href="#"
           @click.prevent="onClickStaffLink"><span class="wrap-text">{{invoiceApproval.staff.userName}}</span></a>
    </div>
    <div v-if="!isForBranchPage"
         class="col-1 align-self-center"><span class="wrap-text">{{invoiceApproval.staff.branch}}</span></div>
    <div class="col-5 align-self-center container"
         :class="{'col-6': isForBranchPage}">
        <div v-for="msg in invoiceApproval.messages"
             :key="msg.vForKey"
             class="row"
             :style="{fontSize: FontSizes.small1}">
            <div class="col-8 text-left px-1">● {{ msg.message }}</div>
            <div class="col-4 align-self-center px-1">{{ msg.datetime }}</div>
        </div>
    </div>
    <div class="col-3 align-self-center mx-n1"
         :class="stateStyleClass()"><span class="wrap-text">{{ approvalStateText() }}</span></div>
</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {InvoiceApproval} from "@/data-models/invoice-approval";
import {useRoute, useRouter} from "vue-router";
import {loadingOverlayStateStore} from "@/stores/loading-overlay-state-store";
import {subPaths} from "@/utils/consts";
import {FontSizes} from "@/utils/font-sizes";

export default defineComponent({
    name: "InvoiceApprovalListCell",
    props: {
        invoiceApproval: {
            type: Object as PropType<InvoiceApproval>,
            required: true
        },
        isForBranchPage: {
            type: Boolean,
            default: false,
        }
    },
    setup(props) {

        const router = useRouter()

        const approvedText = "請求額承認済み",
            approvedByBranch = "支店による承認済み",
                disapprovedText = "請求額未承認"

        const approvalStateText = (): string => {
            return props.invoiceApproval.accept
                ? props.invoiceApproval.state === "approved_by_branch"
                    ? approvedByBranch
                    : approvedText
                : disapprovedText
        }

        const onClickStaffLink = () => {
            loadingOverlayStateStore.commit("switchLoadingState", {
                show: true,
                message: "スタッフページへ移動中…",
                shouldTimeOut: false,
            })
            router.push({
                path: subPaths.MY_PAGE_INVOICE_OF_MONTH,
                query: {
                    staff_id: props.invoiceApproval.staffId
                }
            })
        }

        const stateStyleClass = (): string => {
            return props.invoiceApproval.accept
                ? props.invoiceApproval.state === "approved_by_branch"
                    ? "invoice-approved-by-branch"
                    : "invoice-approved"
                : "invoice-disapproved"
        }

        return {
            approvalStateText,
            onClickStaffLink,
            FontSizes,
            stateStyleClass,
        }
    }
})
</script>

<style scoped lang="scss">
.cell-frame {
    display: flex;
    border: 1px solid lightgray;
    min-height: 40px;
    padding-top: 5px;
    padding-bottom: 5px;
}

.invoice-approved {
    color: green;
}

.invoice-approved-by-branch {
    color: blue;
}

.invoice-disapproved {
    color: red;
}

</style>